import axios from 'axios';
import { feathers } from '@/feathers-client';

const initialState = {
  files: [],
  fileFolders: [],
  fileError: false,
  fileFolderError: false,
  fileErrorMessage: '',
  fileFolderErrorMessage: '',
};

export default {
  namespaced: true,
  state: {
    ...initialState,
  },
  mutations: {
    setFileFolders(state, fileFolders) {
      state.fileFolders = fileFolders;
    },
    setFiles(state, files) {
      state.files = files;
    },
    addFiles(state, files) {
      state.files = [
        ...state.files,
        ...files,
      ];
    },
    addFileFolders(state, fileFolders) {
      state.fileFolders = [
        ...state.fileFolders,
        ...fileFolders,
      ];
    },
    setFileError(state, bool) {
      state.fileError = bool;
    },
    setFileFolderError(state, bool) {
      state.fileFolderError = bool;
    },
    setFileErrorMessage(state, error) {
      state.fileErrorMessage = error;
    },
    setFileFolderErrorMessage(state, error) {
      state.fileFolderErrorMessage = error;
    },
  },
  getters: {
    getTodayEvocalizeAdReport: state => {
      if (!state.files.length) return;
      return state.files.find(file => {
        const fileName = 'Liondesk-Ad-Portal-Report';
        const fileCreatedAt = new Date(file.created_at).toDateString();
        const now = new Date().toDateString();

        return file.name.startsWith(fileName) && fileCreatedAt === now;
      });
    }
  },
  actions: {
    async findFileFolders({ commit }, query) {
      commit('setFileFolderError', false);
      try {
        const { data } = await feathers.service('file-folders').find({ query });
        commit('setFileFolders', data);
      } catch (error) {
        commit('setFileFolderError', true);
        commit('setFileFolderErrorMessage', error);
      }
    },
    async findFiles({ commit }, query) {
      commit('setFileError', false);
      try {
        const { data } = await feathers.service('files').find({ query });
        commit('setFiles', data);
      } catch(error) {
        commit('setFileError', true);
        commit('setFileErrorMessage', error);
      }
    },
    async createAdReport({ commit }, fileFolderId) {
      commit('setFileError', false);
      const body = { "folder_id": fileFolderId };
      try {
        const { data } = await axios.post(`${process.env.VUE_APP_ACCOUNTS_API}/users/evocalize-ad-report`, body);
        commit('addFiles', [data]);
      } catch(error) {
        commit('setFileError', true);
        commit('setFileErrorMessage', error);
      }
    },
    async createFileFolder({ commit }, fileFolderName) {
      commit('setFileFolderError', false);
      const body = { "folder_name": fileFolderName }
      try {
        const file = await feathers.service('file-folders').create(body);
        commit('addFileFolders', [file])
      } catch(error) {
        commit('setFileFolderError', true);
        commit('setFileFolderErrorMessage', error);
      }
    }
  },
};
